<template>
    <div>

        <div class="d-flex flex-row">
            <div class="h5 flex-grow-1" >Новый вид</div>

            <div class="d-flex">
                <div class="flex-grow-0">
                    <b-button variant="outline-secondary" size="lg" class="border-0 p-0"  @click="onCancel">
                        <b-icon icon="x" />
                    </b-button>
                </div>
            </div>
        </div>

        <b-form-row class="w-100 mt-4 mb-2">
            <form-field class="col-12 required mb-2"
                         :label="getFieldLabel('name')"
                         :editable="getAbility('name')"
                         :value="getObjectField('name')"
                         :feedback="liveFeedback('name')">
                <template #field>
                    <b-form-input
                        id="name"
                        class="w-100"
                        type="text"
                        v-model="$v.form.name.$model"
                        :state="validateState('name')">
                    </b-form-input>
                </template>
            </form-field>
        </b-form-row>

        <div class="d-flex col-12 mt-3 p-0">
            <div class="d-flex flex-grow-1 justify-content-end">
                <b-button @click="onCreate" v-if="!object.id" variant="primary">Создать</b-button>
            </div>
        </div>

    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import FormField from "@/components/Forms/FormField";
import {Species} from "@/pages/AppPages/Catalogs/Animals/species";
import api from "@/api";

export default {
    name: "SpeciesCreateModal",
    components: {FormField},
    mixins: [ ObjectComponentMixin ],
    computed: {
        createUrl() {
            return api.species.default.list();
        },
    },
    methods: {
        onCancel() { // TODO: move to ObjectComponentMixin
            this.$emit('object-modal-closed');
        },
        onCreate() { // TODO: move to ObjectComponentMixin
            this.submitAction().then((response) => {
                this.$emit('object-modal-created', response.data);
        })},
    },
    beforeMount() {
        this.objectClass = Species;
        this.objectId = null;
    },
    mounted() {
        this.onMount();
        this.resetForm();
    },
}
</script>

<style scoped>

</style>